"use client";

import { cn } from "@ui/lib/utils";
import { useTranslations } from "next-intl";

import type { PresetCategory } from "../types";

import { setActivePresetCategory } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { SoundBoardButton } from "./SoundBoardButton";

export const PresetCategorySelector = ({ category, full }: { category: PresetCategory; full?: boolean }) => {
  const { dispatch, state } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");

  const handleClick = () => {
    dispatch(setActivePresetCategory({ category }));
  };
  return (
    <SoundBoardButton
      className={cn(
        "control-button",
        state.activePresetCategory === category && "selected",
        full ? "aspect-1x1" : "aspect-2x1",
      )}
      onClick={handleClick}
    >
      <p className='font-soundboard f-ui-04 w-full truncate text-inverse'>
        {t(`preset_category_selector.${category}`)}
      </p>
    </SoundBoardButton>
  );
};
